'use strict';
var React = require('react');
var Components = require('./Components.jsx');
var _ = require('underscore');

var Top = React.createClass({
  propTypes: {
    components: React.PropTypes.array.isRequired,
    top: React.PropTypes.number.isRequired,
    events: React.PropTypes.object.isRequired,
    onLinkClick: React.PropTypes.func.isRequired,
    onLoad: React.PropTypes.func.isRequired
  },
  render: function () {
    var top = this.props.top;
    var shouldRenderComponents = _.filter(this.props.components, function (item) {
      if (item.controlTypeID === 'ImageCarousel') {
        return top - item.y > 5;
      }
      return item.y <= top;
    });
    return (
      <div key="top-page" className='page-top' style={{height: this.props.top}}>
        <Components components={shouldRenderComponents} events={this.props.events} onLoad={this.props.onLoad}/>
      </div>
    );
  }
});

module.exports = Top;


// WEBPACK FOOTER //
// ./src/views/Page/Top.jsx